import { AuthorityType } from '@/types'

export interface UpdateAuthoritySubRequest {
  authorityType: AuthorityType
  authorityNo: string
  targetAuthorityNo: string
}

export function UpdateAuthoritySubRequestToJSON(
  value: UpdateAuthoritySubRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined,
    target_authority_no:
      value.targetAuthorityNo !== '' ? value.targetAuthorityNo : undefined
  }
}
